import React from 'react';

import { Nullable } from '@clearverify/types';

import { useCurrentUserPermissions } from 'src/hooks/user';

import { PeoStaffViewDetailsModalFormAdvanced } from './PeoStaffViewDetailsModalFormAdvanced';
import { PeoStaffViewDetailsModalFormMinimal } from './PeoStaffViewDetailsModalFormMinimal';

interface PeoStaffViewDetailsModalFormProps {
  peoStaffId: Nullable<string>;
  handleCloseModal: () => void;
  switchClosability: (isClosureAllowed: boolean) => void;
}

export const PeoStaffViewDetailsModalForm: React.FC<PeoStaffViewDetailsModalFormProps> = ({
  peoStaffId,
  handleCloseModal,
  switchClosability,
}) => {
  const { hasPlatformRoles, isPeoPayrollProviderUser, isPeoSuperAdmin } =
    useCurrentUserPermissions();

  const canSetupAccessRestriction = hasPlatformRoles || isPeoPayrollProviderUser || isPeoSuperAdmin;
  const canEditStatusAndRole = hasPlatformRoles;

  if (canSetupAccessRestriction || canEditStatusAndRole) {
    return (
      <PeoStaffViewDetailsModalFormAdvanced
        peoStaffId={peoStaffId}
        handleCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        canEditStatusAndRole={canEditStatusAndRole}
        canSetupAccessRestriction={canSetupAccessRestriction}
      />
    );
  }

  return (
    <PeoStaffViewDetailsModalFormMinimal
      peoStaffId={peoStaffId}
      handleCloseModal={handleCloseModal}
    />
  );
};
